// TODO: Rename these variables to camelCase
const PaymentTypesEnum_Default = {
  braintree: 0,
  paypal: 1,
  polipay: 2,
  onAccount: 3,
};

const PaymentTypesEnum_CCC = {
  ...PaymentTypesEnum_Default,
  voucher: 4,
};
Object.freeze(PaymentTypesEnum_CCC);

const PaymentTypesEnum_Sealink = {
  ...PaymentTypesEnum_Default,
  savedCard: 4,
};

export {
  PaymentTypesEnum_Default,
  PaymentTypesEnum_CCC,
  PaymentTypesEnum_Sealink,
};
